import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./hallImgCarousel.scss";
// utils
import { getImageUrlWithMaxWidth } from "@src/utils";
// import { IPhotoData } from "@src/components/partner/photo/Interface";
import notFound from "@assets/images/partner/img-notfound@3x.jpg";
// import PhotoModalWrap from "@src/components/common/wrap/PhotoModalWrap";
// hooks
import { useInterWindow } from "@src/utils/hooks/useInterWindow";
import { resetInterWindow } from "@src/@slice/interWindowSlice";
import { useDispatch } from "react-redux";
import LazyImage from "@src/components/common/image/LazyImage";

type Props = {
  type: "hall" | "hallDetail" | "hallCard"; // hall: 웨딩홀 대표이미지, hallCard: 웨딩홀페이지 개별홀 카드, hallDetail: 개별홀 페이지에서 쓰임, advertise: 광고형 
  isDiscount?: boolean; // 할인 태그 표시 여부 
  indicatorType?: "dot" | "number" | 'none'; // 이미지 인디케이터 타입
  width?: number;
  height: number; // 이미지 높이
  swipeable?: boolean; //이미지 스와이프 가능 여부
  imgs: { url: string; title: string }[];
  imgClick?: () => void; // 클릭 핸들러
};

export default function HallImgCarousel({
  type,
  isDiscount = false,
  indicatorType = "number",
  width = window.innerWidth,
  height,
  swipeable = true,
  imgs,
  imgClick = () => { },
}: Props) {
  const dispatch = useDispatch();
  const [photoModalData, setPhotoModalData] = useState({
    id: Date.now(),
    idx: 0,
    photoData: imgs,
    total: imgs.length,
  });
  const [currentSlide, setCurrentSlide] = useState(1);

  const SETTINGS = {
    dots: indicatorType === "dot",
    infinite: false,
    speed: 500,
    afterChange: (currentSlide: number) => setCurrentSlide(currentSlide + 1),
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // 이미지 모달 열기 설정
  const { openWindow: openImage } = useInterWindow({
    id: "hallDetailImgs",
    receiverId: "image",
    // needResetData: false,
  });

  // 리뷰.포토 등 새창으로 열리는 데이터 초기화
  useEffect(() => {
    dispatch(resetInterWindow());
  }, []);

  const handleClick = (index: number) => {
    if (type === "hall") {
      // 웨딩홀 페이지 대표이미지 클릭시 사진탭 이동
      imgClick();
    } else if (type === "hallDetail") {
      // 개별홀 페이지
      const data = { ...photoModalData, idx: index, id: Date.now() };
      setPhotoModalData(data);
      openImage(
        {
          photoData: data,
        },
        {
          url: `/image`,
          hidetop: true,
          hidesafearea: false,
        },
      );
    }
  };

  return (
    <div className="slider-container" style={{ height }}>
      {swipeable ?
        <Slider {...SETTINGS}>
          {imgs.map(({ url, title }, i) => (
            <div key={i} onClick={() => handleClick(i)}>
              <LazyImage
                image={{
                  src: (!!url ? url : notFound),
                  width: width,
                  height: height,
                  alt: title + i,
                  style: { height: height }
                }}
              />
              {/* <img src={!!url ? url : notFound} alt={title + i} style={{ height }} /> */}
            </div>
          ))}
        </Slider>
        :
        <>
          {imgs.slice(0, 1).map(({ url, title }, i) => (
            <div key={i} onClick={() => handleClick(i)}>
              <LazyImage
                image={{
                  src: (!!url ? url : notFound),
                  width: width,
                  height: height,
                  alt: title + i,
                  style: { height: height }
                }}
              />
            </div>
          ))}
        </>
      }

      {indicatorType === "number" && (
        <div className="indicator-wrap">
          <p>
            {currentSlide}/{imgs.length}
          </p>
        </div>
      )}
      {isDiscount && (
        <span className="discount-tag">
          방문 시 추가 할인
        </span>
      )}
    </div>
  );
}
